/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'organization': {
    width: 29,
    height: 26,
    viewBox: '0 0 29 26',
    data: '<path pid="0" d="M4.366 14.922c0-1.648 1.54-2.89 3.298-2.89h6.011V9.538A4.359 4.359 0 0114.501.9a4.357 4.357 0 01.824 8.637v2.496h6.011c1.759 0 3.298 1.242 3.298 2.889v1.855a4.357 4.357 0 11-1.65-.026v-1.83c0-.709-.8-1.24-1.648-1.24h-6.01v3.081a4.357 4.357 0 11-1.65 0l-.001-3.08H7.664c-.848 0-1.648.53-1.648 1.238v1.831a4.357 4.357 0 11-1.65.028v-1.857zM14.5 2.55a2.706 2.706 0 100 5.412 2.706 2.706 0 000-5.412zm0 15.786a2.706 2.706 0 100 5.413 2.706 2.706 0 000-5.413zm9.244 0a2.705 2.705 0 00-2.706 2.707 2.706 2.706 0 102.706-2.707zm-18.487 0a2.706 2.706 0 100 5.413 2.706 2.706 0 000-5.413z" _fill="#FFF" fill-rule="nonzero"/>'
  }
})
